import Ajax from '@utils/ajax';
import { AxiosPromise } from 'axios';
import { Currency } from '../types';

export const getCurrencies = (): AxiosPromise<{ data?: Currency[] }> => {
	return Ajax.get('/ajax/get_currency');
};
